import * as Types from '../api/graphql';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type UploadUrlQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UploadUrlQuery = { uploadUrl: { __typename: 'SignedUrlResponse', key: string, url: string } };


export const UploadUrlDocument: DocumentNode<UploadUrlQuery, UploadUrlQueryVariables> = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UploadUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]};